import React from 'react';

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  color?: string;
  label?: string;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onChange,
  disabled = false,
  size = 'medium',
  color = '#FF6F0F',
  label
}) => {
  const sizeConfig = {
    small: { width: '30px', height: '18px', circleSize: '14px', translateX: '12px' },
    medium: { width: '49px', height: '25px', circleSize: '21px', translateX: '24px' },
    large: { width: '60px', height: '30px', circleSize: '24px', translateX: '30px' }
  };

  const config = sizeConfig[size];

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    }}>
      <label style={{
        position: 'relative',
        display: 'inline-block',
        width: config.width,
        height: config.height,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1
      }}>
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
          style={{
            opacity: 0,
            width: 0,
            height: 0
          }}
        />
        <span style={{
          position: 'absolute',
          cursor: disabled ? 'not-allowed' : 'pointer',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: checked ? color : '#EDEDED',
          transition: '0.4s',
          borderRadius: '9999px'
        }}>
          <span style={{
            position: 'absolute',
            height: config.circleSize,
            width: config.circleSize,
            left: '2px',
            bottom: '2px',
            backgroundColor: 'white',
            transition: '0.4s',
            borderRadius: '9999px',
            transform: checked ? `translateX(${config.translateX})` : 'translateX(0)',
          }} />
        </span>
      </label>
      {label && (
        <span style={{
          fontSize: '14px',
          color: disabled ? '#999' : '#333',
          userSelect: 'none'
        }}>
          {label}
        </span>
      )}
    </div>
  );
};

export default ToggleSwitch;
